import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IAuthToken {
    isAuthenticated?: boolean,
    jwtToken: string;
    expiryDate: any;
    errorMessage?: string;
    userData?: any;
    response?:any;
}

const initialState: IAuthToken = {
    jwtToken: '',
    expiryDate: undefined,
    errorMessage: '',
    isAuthenticated: false,
    userData: undefined,
    response:undefined,

};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setJWTToken: (state, _action: PayloadAction<IAuthToken>) => {
            state.jwtToken = _action.payload.jwtToken;
            state.expiryDate = _action.payload.expiryDate;
            state.userData = _action.payload.userData;
            localStorage.setItem('token', state.jwtToken);
            localStorage.setItem('expire', state.expiryDate);
            localStorage.setItem("desig_level_id", state.userData.desig_level_id);
            localStorage.setItem("vibhag_id", state.userData.vibhag_id);
            localStorage.setItem("member_name", state.userData.member_name);
            localStorage.setItem("zill_id", state.userData.zill_id);
            localStorage.setItem("nagar_khanda_id", state.userData.nagar_khanda_id);
            localStorage.setItem("upamandal_basti_id", state.userData.upamandal_basti_id);

            if (state.userData) {
                localStorage.setItem('userData', JSON.stringify(state.userData));
                state.isAuthenticated = true;
            }else{
                state.isAuthenticated = false;
            }
          


        },
        removeJWTToken: (state) => {
            localStorage.clear();
            state.jwtToken = '';
            state.expiryDate = undefined;
            state.isAuthenticated = false;
        },
        setError: (state, _action: PayloadAction<string>) => {
            state.errorMessage = _action.payload;
        },
    },
});

export const { setJWTToken, removeJWTToken, setError } = authSlice.actions;

export default authSlice.reducer;

